import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// API function
export const getPermissions = async () => {
    try {
        const response = await Axios.get(`/user-permissions`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            return error?.response?.data;
        }
        throw new Error(error.message || "Network Error");
    }
};

// React Query hook
export const useGetPermissions = () => {
    return useQuery({
        queryKey: ["get-permissions"],
        queryFn: () => getPermissions(),
    });
};
